import { WorkoutSettings } from '@sworkit/api';

export const workoutSettingsDefaults: WorkoutSettings = {
  shouldPerformWarmUp: true,
  shouldPlayRestBreaks: true,
  leadInBreakSeconds: 5,
  exerciseLength: 30,
  poseLength: 20,
  breakFrequency: 5,
  breakLength: 30,
  shouldShuffleExercises: true,
  shouldPlayInstructionalCues: true,
  shouldPlayExerciseNameAudio: true,
  shouldPlayMotivationalAudio: true,
  shouldPlayNextExerciseAudio: true,
  shouldPlayWelcomeAndCongratsAudio: true,
  countdownAudioStyle: 'voice',
  trainerVoice: 'kelly',
};
